import {
  Component,
  OnInit,
  Output,
  Input,
  ViewChildren,
  QueryList,
  EventEmitter,
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes
} from '@angular/core';
import {
  UsersService
} from "../../../../injections/users.service";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import {
  Subject,
  Subscription
} from 'rxjs/Rx';
import { PredictiveComponent } from '../../../../common/predictive/predictive.component';
import {Router} from "@angular/router";

@Component({
  moduleId: module.id,
  selector: 'search-user',
  templateUrl: '../../templates/partials/search-user.html',
  providers: [],
  animations: [
    trigger('searchUser', [
            state('void', style({
                overflow: 'hidden',
                "max-height": '0'
                
            })),
            state('inactive', style({
                overflow: 'hidden',
                "max-height": '0'
                
            })),
            state('active', style({
                display: 'block',
                "max-height": '1000px',

            })),
            transition('inactive => active', animate('400ms ease-in')),
            transition('active => inactive', animate('400ms ease-out'))
        ]),
  ]
})

export class SearchComponent implements OnInit{

  public isCollapsedContent: boolean = false;
  @Input() searchInfo: string = null;
  @Output() searchCifEmitter = new EventEmitter();
  public cif;
  public searchData: object = {
    legalName: null,
    trademark: null,
    contactName: null,
    email: null,
    cif: null
  };
  @ViewChildren(PredictiveComponent) predictives: QueryList<PredictiveComponent>;
  public state: string;
  selected: number = 0;


  constructor(private usersService: UsersService, private router: Router) {}

  public toggleMove() {
    if (this.state == 'inactive') {
      this.searchInfo = null;
    }
    this.state = (this.state === 'inactive' ? 'active' : 'inactive');
  }

  public searchUsers(cif: any, $event: Event) {
    this.predictives.forEach((item) => {
      if(item.inputValue != ''){ 
        this.setSearchData(item);
      }else{
        item.items = [];
      }
    });

  }

  public goToUser(value: object){
    this.router.navigate(['/users', value["id"]]);
  }

  public emptyPredictiveArray(type){
    this.predictives.forEach((item) => {
        if(type != item.type){
          item.items = [];
          item.inputValue = null;
        }else{
          if(item.inputValue != ''){
            this.setPredictive(item);
          }else{
            item.items = [];
          }
        }
    });    
  }

  public search() {
    console.log(this.predictives);
    //this.searchCifEmitter.emit(this.cif);
    //this.state = "inactive";
  }

  private setSearchData(predictive: PredictiveComponent){

      switch(predictive["type"]){

        case "name":
        this.searchData["legalName"] = predictive["inputValue"];
        break;

        case "trademark":
        this.searchData["trademark"] = predictive["inputValue"];
        break;

        case "contact":
        this.searchData["contactPerson"] = predictive["inputValue"];
        break;

        case "email":
        this.searchData["email"] = predictive["inputValue"];
        break;
      }

  }

  private setPredictive(predictive: PredictiveComponent) {

      switch (predictive.type){

        case 'name':
        this.usersService.findUserByFullName(predictive.inputValue)
        .distinctUntilChanged()
        .debounceTime(1000)
        .subscribe(
          result => {
          if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
          },
          error => {
            predictive.items = []
          }
          );
        break;

        case 'surname':
        this.usersService.findUserBySurname(predictive.inputValue)
        .distinctUntilChanged()
        .debounceTime(1000)
        .subscribe(result => {
          if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
        });
        break;

        case 'phone':
        this.usersService.findUserByPhone(predictive.inputValue)
        .distinctUntilChanged()
        .debounceTime(1000)
        .subscribe(
          result => {
            if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
          },
          error => {
            //console.log(error);
          }
        );
        break;

        case 'email':
        this.usersService.findUserByEmail(predictive.inputValue)
        .distinctUntilChanged()
        .debounceTime(1000)
        .subscribe(
          result => {
            if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
          },
          error => {
            //console.log(error);
          }
        );
        break;

      }
  }
  
  ngOnInit(){}

}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/search.component.ts